module.exports = __webpack_public_path__ + "img/Snare.0fb7d7fc.png";